import { useEffect, useRef } from 'react'

export function CursorGlow() {
  const ref = useRef(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return undefined

    let frame = null
    const move = (event) => {
      if (frame) cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => {
        element.style.left = `${event.clientX}px`
        element.style.top = `${event.clientY}px`
        element.style.opacity = '1'
      })
    }
    const leave = () => {
      element.style.opacity = '0'
    }

    window.addEventListener('pointermove', move, { passive: true })
    document.documentElement.addEventListener('mouseleave', leave)

    return () => {
      if (frame) cancelAnimationFrame(frame)
      window.removeEventListener('pointermove', move)
      document.documentElement.removeEventListener('mouseleave', leave)
    }
  }, [])

  return <div ref={ref} className="cursor-glow opacity-0" aria-hidden="true" />
}
